module.exports = __webpack_public_path__ + "static/media/PeanutPaste.0834922c.pdf";